// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import compass01Icon from "@/assets/icons/compass-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Compass01IconProps = Omit<IconProps, "name">;

export function Compass01Icon(props: Compass01IconProps): React.ReactNode {
  return <Icon name={compass01Icon} {...props} />;
}
